import { c as _c } from "react/compiler-runtime";
import './feature-article-card.scss';
import { SkeletonImage } from '@sola/ark-core/atoms/skeleton-image/skeleton-image.tsx';
import { Skeleton, type SkeletonProps } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
const CardSkeleton: React.FC<SkeletonProps> = t0 => {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Skeleton variant="dark" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export const FeaturedArticleCardSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="FeaturedArticleCard__media"><SkeletonImage width="100%" height="100%" className="FeaturedArticleCard__image" borderRadius="var(--outline-radius-lg)" /><div className="FeaturedArticleCard__media-overlay" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-comfy-md"><CardSkeleton height={30} width="85%" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="FeaturedArticleCard w-full max-w-xl mx-auto aspect-ratio-1 @md:aspect-ratio-16-9 @lg:aspect-ratio-21-9">{t0}<div className="FeaturedArticleCard__content"><div className="max-w-md @lg:pr-roomy-md mb-roomy-sm">{t1}<div className="flex flex-col gap-snug-lg mb-roomy-md"><CardSkeleton height={18} width="80%" /><CardSkeleton height={18} width="90%" /><CardSkeleton height={18} width="65%" /></div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};